// A camada que desenha o retângulo flutuante enquanto o usuário arrasta.
import React from "react";
import { useDragLayer } from "react-dnd";
import * as AlfredoStyles from "../../../../styles/components/configuration/modals/ItemModal";
import { COMPONENT_TYPES } from "./catalogoDeComponentes";

const useDragPreview = () => {
  return useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));
};

export const CamadaDePreviaDoArraste: React.FC = () => {
  const { isDragging, item, itemType, currentOffset } = useDragPreview();

  if (!isDragging || !currentOffset) {
    return null;
  }

  const getPreviewContent = () => {
    if (itemType === "COMPONENT" && item?.component) {
      return item.component.componentName;
    } else if (itemType === "NEW_COMPONENT") {
      const componentType = COMPONENT_TYPES.find(
        (c) => c.id === item?.componentType
      );
      return componentType
        ? `Adicionar ${componentType.name}`
        : "Novo Componente";
    }
    return "Arrastando...";
  };

  return (
    <AlfredoStyles.DragPreviewLayer>
      <AlfredoStyles.DragPreviewItem
        style={{
          transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
        }}
      >
        {getPreviewContent()}
      </AlfredoStyles.DragPreviewItem>
    </AlfredoStyles.DragPreviewLayer>
  );
};
